import React, { Fragment, useContext, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../components/AppProvider";
import { AlertLayer } from "../../components/UI/Dialog";
import { InputDivSearch } from "../../components/UI/INPUT/InputDivSearch";
import { PostApiHsptList } from "../../modules/network/padoPost";
import { ContainerNew, SubMenu, openLayerFn } from "../Layout";

export default (props) => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const { searchList, setSearchList } = useState();

  const requestHsptList = (userinfo, cfg, phonecfg, searchType, hpNm) => {
    PostApiHsptList(userinfo, cfg, phonecfg, searchType, hpNm)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") setSearchList(res.result.hsptList);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
    url: "",
  });

  const bottom = (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}
    >
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          alert("인증번호 요청");
        }}
      >
        인증번호 요청
      </BtnNext>
    </div>
  );

  return (
    <Fragment>
      <ContainerNew
        Title={"병원 대면 인증"}
        dark={"dark"}
        leftMenu={SubMenu}
        rightMenu={-1}
        bottom={bottom}
        isMain={true}
      >
        <Contents>
          <SubTitle>병원 대면 인증</SubTitle>
          <div style={{ padding: "8px 0px" }}>
            <p>
              <font style={{ color: "red", fontSize: "16px" }}>
                병원 내부에서 의료진이 대면으로 인증 합니다.
              </font>
            </p>
            <p>방문하신 병원을 입력해주세요.</p>
          </div>

          {/* input area */}
          <div>
            <InputDivSearch searchEvent={requestHsptList} />
          </div>
        </Contents>
      </ContainerNew>
      <AlertLayer title={dialog.title} msg={dialog.msg} url={dialog.url} />
    </Fragment>
  );
};

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};

const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 37px;
`;

const BtnNext = styled.div`
  bottom: 86px;
  width: ${(props) => window.innerWidth - 30}px;
  height: 50px;
  line-height: 50px;
  background: #000000 0% 0% no-repeat padding-box;
  color: #fff;
  border-radius: 4px;
  opacity: 1;
  font-size: 17px;
`;
